import * as yup from 'yup';

export const giftCardBalanceSchema = yup.object().shape({
  giftCardNumber: yup.string().min(16, 'giftcard.not.valid').max(32, 'giftcard.not.valid'),
});
